import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { SWRConfig } from 'swr';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import { Home, Data, Import, Tenant, User, Setting, Chart, Download} from './pages';
import { Layout } from './components';
import './styles/main.scss';
import reportWebVitals from './reportWebVitals';
import { CookiesProvider } from 'react-cookie';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

declare global {
  /* eslint-disable @typescript-eslint/no-unused-vars */
  interface Window {
    gtag?: (
      key: string,
      trackingId: string,
      // eslint-disable-next-line camelcase
      config: { page_path: string }
    ) => void;
  }
}

root.render(
  // <React.StrictMode>
  <CookiesProvider>
    <SWRConfig
      value={{
        fetcher: (resource, init) => fetch(resource, init).then(res => res.json())
      }}
    >
      <Router>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/Data" element={<Data />} />
            <Route path="/Import" element={<Import />} />
            <Route path="/Tenant" element={<Tenant />} />
            <Route path="/User" element={<User />} />
            <Route path="/Setting" element={<Setting />} />
            <Route path="/Chart" element={<Chart />} />
            <Route path="/Download" element={<Download />} />
            <Route path="/*" element={<Navigate replace to="/" />} />
          </Routes>
        </Layout>
      </Router>
    </SWRConfig>
  </CookiesProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();